var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "fill-parent-container"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('textarea', {
    staticClass: "container-answer noselect",
    attrs: {
      "id": "answerWithButton",
      "autoFocus": "",
      "rows": "1"
    },
    domProps: {
      "value": _vm.answerLocal
    }
  }), _vm.answerLocal && _vm.answerLocal.trim().length > 0 ? _c('done-button', {
    class: ['done-button', _vm.answerLocal ? '' : 'hidden'],
    attrs: {
      "on-click": _vm.done,
      "transition": _vm.innerTransition,
      "text": "Done"
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }